export interface Clock {
  nowUtc(): number;
}

export const systemClock: Clock = {
  nowUtc: () => Date.now(),
};

export class FakeClock implements Clock {
  public constructor(private current: number) {}

  public nowUtc(): number {
    return this.current;
  }

  public advance(milliseconds: number): void {
    this.current += milliseconds;
  }
}
